import styled from "styled-components";
import theme from "../../Styles/theme";

export const Container = styled.div``;

export const Text = styled.p`
      font-size: max(15px, 1.5vw);
      color: ${theme.colors.dark};
      text-align:center;

`;


export const ButtonDiv = styled.div`

    display: flex;
    align-items:center;
    justify-content:space-around;
    margin-top:2vh;

`;


export const Button = styled.button`

    background-color: ${theme.colors.darkGrey};
    color:${theme.colors.dark};
    font-size: max(12px, 1.2vw);
    padding:1vh 2vw;
    border-radius:0.25rem;
`;


